import Header from "../sections/header";
import Scrollbar from "../components/scrollbar";
import Info from "../sections/info";
import Participate from "../sections/participate";
import Players from "../sections/players";
import History from "../sections/history";
import Footer from "../sections/footer";
import React from "react";

export default function Main() {
    return (
        <div className="min-h-[100vh] bg-gradient-to-b from-blue-light to-blue-dark flex flex-col gap-14 overflow-y-hidden">
            <Header/>
            <Scrollbar/>
            <div className="min-h-[100dvh]">
                <div className="max-w-[1500px] mx-auto flex flex-col gap-14">
                    <Info/>
                    <Participate/>
                    <Players/>
                    {/**<Download/>**/}
                    <History/>
                </div>
            </div>
            <Footer/>
        </div>
    );
}